module.exports = __webpack_public_path__ + "static/background-1-62e1f51416843c77718b6919a2ac1e56.svg";